import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";
import { useParams, Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import "./TrainingRequestDetails.css";

function TrainingRequestDetails() {
  const [isLoading, setIsLoading] = useState(true);
  const [request, setRequest] = useState({});
  const [training, setTraining] = useState({});
  const { t } = useTranslation();

  const dayjs = require("dayjs");

  let { rid } = useParams();

  const { state } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingRequests/request/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setRequest(response.data.request);
      setTraining(response.data.training);
      setIsLoading(false);
    }
    fetch();
  }, [state.organization, state.language, state.token, rid]);

  const approveRequest = async () => {
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND_URL}/trainingRequests/approve/status/${rid}`,
      data: {
        userId: state.userId,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    navigate("/trainings/requests");
  };

  const rejectRequest = async () => {
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND_URL}/trainingRequests/reject/status/${rid}`,
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    navigate("/trainings/requests");
  };

  const mxnFormatter = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
  });

  const selectAlert = (status) => {
    if (status === "approved") {
      return (
        <Alert variant="primary">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.Aprobado")}
        </Alert>
      );
    } else if (status === "hrApproved") {
      return (
        <Alert variant="success">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.AprobadoRH")}
        </Alert>
      );
    } else if (status === "bossApproved") {
      return (
        <Alert variant="success">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.AprobadoJefe")}
        </Alert>
      );
    } else if (status === "pending") {
      return (
        <Alert variant="secondary">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.Pendiente")}
        </Alert>
      );
    } else if (status === "rejected") {
      return (
        <Alert variant="danger">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.Rechazado")}
        </Alert>
      );
    }
  };

  const generateButtons = (status, requester, requesterBoss) => {
    if (status === "pending") {
      if (state.role === "root" || state.role === "admin") {
        return (
          <>
            <Button variant="primary" onClick={() => approveRequest()}>
              {t("Capacitaciones.SolicitudesCapacitacion.Aprobar")}
            </Button>
            <Button variant="danger" onClick={() => rejectRequest()}>
              {t("Capacitaciones.SolicitudesCapacitacion.Rechazar")}
            </Button>
            <Link to="/trainings/requests">
              <Button variant="secondary">
                {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
              </Button>
            </Link>
          </>
        );
      } else if (state.userId.toString() === requesterBoss.toString()) {
        return (
          <>
            <Button variant="primary" onClick={() => approveRequest()}>
              {t("Capacitaciones.SolicitudesCapacitacion.Aprobar")}
            </Button>
            <Button variant="danger" onClick={() => rejectRequest()}>
              {t("Capacitaciones.SolicitudesCapacitacion.Rechazar")}
            </Button>
            <Link to="/trainings/requests">
              <Button variant="secondary">
                {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
              </Button>
            </Link>
          </>
        );
      } else if (state.userId.toString() === requester.toString()) {
        return (
          <Link to="/trainings/requests">
            <Button variant="secondary">
              {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
            </Button>
          </Link>
        );
      } else {
        return (
          <Link to="/trainings/requests">
            <Button variant="secondary">
              {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
            </Button>
          </Link>
        );
      }
    } else if (status === "hrApproved") {
      if (state.role === "root" || state.role === "admin") {
        if (state.userId.toString() === requesterBoss.toString()) {
          return (
            <>
              <Button variant="primary" onClick={() => approveRequest()}>
                {t("Capacitaciones.SolicitudesCapacitacion.Aprobar")}
              </Button>
              <Button variant="danger" onClick={() => rejectRequest()}>
                {t("Capacitaciones.SolicitudesCapacitacion.Rechazar")}
              </Button>
              <Link to="/trainings/requests">
                <Button variant="secondary">
                  {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
                </Button>
              </Link>
            </>
          );
        } else {
          return (
            <Link to="/trainings/requests">
              <Button variant="secondary">
                {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
              </Button>
            </Link>
          );
        }
      } else if (state.userId.toString() === requesterBoss.toString()) {
        return (
          <>
            <Button variant="primary" onClick={() => approveRequest()}>
              {t("Capacitaciones.SolicitudesCapacitacion.Aprobar")}
            </Button>
            <Button variant="danger" onClick={() => rejectRequest()}>
              {t("Capacitaciones.SolicitudesCapacitacion.Rechazar")}
            </Button>
            <Link to="/trainings/requests">
              <Button variant="secondary">
                {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
              </Button>
            </Link>
          </>
        );
      } else if (state.userId.toString() === requester.toString()) {
        return (
          <Link to="/trainings/requests">
            <Button variant="secondary">
              {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
            </Button>
          </Link>
        );
      } else {
        return (
          <Link to="/trainings/requests">
            <Button variant="secondary">
              {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
            </Button>
          </Link>
        );
      }
    } else if (status === "bossApproved") {
      if (state.role === "root" || state.role === "admin") {
        return (
          <>
            <Button variant="primary" onClick={() => approveRequest()}>
              {t("Capacitaciones.SolicitudesCapacitacion.Aprobar")}
            </Button>
            <Button variant="danger" onClick={() => rejectRequest()}>
              {t("Capacitaciones.SolicitudesCapacitacion.Rechazar")}
            </Button>
            <Link to="/trainings/requests">
              <Button variant="secondary">
                {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
              </Button>
            </Link>
          </>
        );
      } else if (state.userId.toString() === requesterBoss.toString()) {
        return (
          <Link to="/trainings/requests">
            <Button variant="secondary">
              {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
            </Button>
          </Link>
        );
      } else if (state.userId.toString() === requester.toString()) {
        return (
          <Link to="/trainings/requests">
            <Button variant="secondary">
              {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
            </Button>
          </Link>
        );
      } else {
        return (
          <Link to="/trainings/requests">
            <Button variant="secondary">
              {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
            </Button>
          </Link>
        );
      }
    } else if (status === "approved") {
      return (
        <Link to="/trainings/requests">
          <Button variant="secondary">
            {t("Capacitaciones.SolicitudesCapacitacion.Regresar")}
          </Button>
        </Link>
      );
    }
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Row className="justify-content-center align-items-center">
        <Col lg={10} className="training-request-details">
          <Col className="mb-3">{selectAlert(request.status)}</Col>
          <Col className="training-request-details-header">
            <h3>{request.trainingName}</h3>
          </Col>
          <Col className="training-request-details-content">
            <Row className="align-items-center justify-content-center">
              <Col lg={3} className="mb-3">
                <h6>{t("Capacitaciones.SolicitudesCapacitacion.Grupo")}:</h6>
              </Col>
              <Col lg={9} className="mb-3">
                {training.trainingGroupName}
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center">
              <Col lg={3} className="mb-3">
                <h6>
                  {t("Capacitaciones.SolicitudesCapacitacion.Proveedor")}:
                </h6>
              </Col>
              <Col lg={9} className="mb-3">
                {training.provider}
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center">
              <Col lg={3} className="mb-3">
                <h6>
                  {t("Capacitaciones.SolicitudesCapacitacion.FechaSolicitud")}:
                </h6>
              </Col>
              <Col lg={9} className="mb-3">
                {dayjs(request.created_at).format("DD/MM/YYYY")}
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center">
              <Col lg={3} className="mb-3">
                <h6>
                  {t("Capacitaciones.SolicitudesCapacitacion.Solicitante")}:
                </h6>
              </Col>
              <Col lg={9} className="mb-3">
                {request.requesterName}
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center">
              <Col lg={3} className="mb-3">
                <h6>{t("Capacitaciones.SolicitudesCapacitacion.Costo")}:</h6>
              </Col>
              <Col lg={9} className="mb-3">
                {mxnFormatter.format(request.cost)}
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center">
              <Col lg={3} className="mb-3">
                <h6>
                  {t(
                    "Capacitaciones.SolicitudesCapacitacion.UsuariosBeneficiados"
                  )}
                  :
                </h6>
              </Col>
              <Col lg={9} className="mb-3">
                {request.users.map((user) => (
                  <span key={user.id} className="user">
                    {user.firstName} {user.lastName} {""}
                  </span>
                ))}
              </Col>
            </Row>
          </Col>
          <Col>
            {generateButtons(
              request.status,
              request.requester,
              request.requesterBoss
            )}
          </Col>
        </Col>
      </Row>
    );
  }
}

export default TrainingRequestDetails;
